import useBenguide from 'hooks/benguide';
import { useAppDispatch } from 'hooks/redux';
import useUPClient from 'modules/clients/UPClient/useUPClient';
import {
  getVisionPlanList,
  reloadVisionSection,
} from 'modules/benefitsWellness/slices/visionSlice';
import { checkBenefitGuidesRates } from 'modules/benefitsWellness/slices/benefitWellnessSlice';
import UPClient from 'modules/clients/UPClient/UPClient';
import {
  VISION_PLAN_CHANNEL,
  RELOAD_VISION_PLAN_LIST,
  RELOAD_VISION_PLAN,
  CHECK_VISION_RATES,
  BENGUIDE_NOTIFICATIONS,
  BENGUIDE_NOTIFICATION_HIDE_OVERLAY,
  BENGUIDE_NOTIFICATION_SHOW_OVERLAY,
} from 'modules/clients/UPClient/UPClientConst';
import MDVTypes from 'modules/benefitsWellness/enums/MDVTypes';

const VisionPlansChannel = () => {
  const dispatch = useAppDispatch();
  const benguide = useBenguide();
  const upClient = useUPClient();
  return (
    <UPClient
      channel={VISION_PLAN_CHANNEL}
      subscribe={(event: string) => {
        switch (event) {
          case RELOAD_VISION_PLAN_LIST:
            dispatch(
              getVisionPlanList(
                benguide.employerId,
                benguide.planYearId,
                benguide.benefitClasses
              )
            );
            break;
          case RELOAD_VISION_PLAN:
            dispatch(
              reloadVisionSection(benguide.masterId, benguide.latestRevision)
            );
            break;
          case CHECK_VISION_RATES:
            dispatch(
              checkBenefitGuidesRates(
                benguide.masterId,
                MDVTypes.VISION.toUpperCase(),
                true
              )
            );
            break;
          case BENGUIDE_NOTIFICATION_HIDE_OVERLAY:
            upClient.postMessage({
              channel: BENGUIDE_NOTIFICATIONS,
              event: BENGUIDE_NOTIFICATION_HIDE_OVERLAY,
              data: {},
            });
            break;
          case BENGUIDE_NOTIFICATION_SHOW_OVERLAY:
            upClient.postMessage({
              channel: BENGUIDE_NOTIFICATIONS,
              event: BENGUIDE_NOTIFICATION_SHOW_OVERLAY,
              data: {},
            });
            break;
        }
      }}
    />
  );
};

export default VisionPlansChannel;
